<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="send-01">
      <path
        id="Icon"
        d="M14.8023 18.0001L28.8023 4.00007M14.9724 18.4375L18.4765 27.4482C18.7852 28.242 18.9396 28.6389 19.162 28.7547C19.3548 28.8552 19.5844 28.8553 19.7774 28.7551C19.9999 28.6395 20.1547 28.2428 20.4643 27.4493L29.2515 4.93233C29.531 4.21609 29.6707 3.85797 29.5943 3.62914C29.5279 3.4304 29.3719 3.27445 29.1732 3.20806C28.9444 3.13161 28.5862 3.27136 27.87 3.55087L5.353 12.338C4.55957 12.6476 4.16285 12.8024 4.04724 13.025C3.94702 13.2179 3.94715 13.4476 4.0476 13.6404C4.16348 13.8628 4.56037 14.0171 5.35417 14.3258L14.3648 17.83C14.526 17.8926 14.6065 17.924 14.6744 17.9723C14.7345 18.0152 14.7871 18.0678 14.83 18.128C14.8784 18.1958 14.9097 18.2764 14.9724 18.4375Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
